'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var InternalToggle_web = require('../../internal/InternalToggle/InternalToggle.web.cjs');
var useAviaryTheme = require('../../../utils/AviaryProvider/helpers/useAviaryTheme.cjs');

/**
 * The theme variant of the Toggle component.
 * Allows users to switch between light and dark themes
 *
 * {@link https://aviary.fullscript.io/latest/components/toggle/theme-toggle-web-7RQ7PiU0-7RQ7PiU0 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/platform/ThemeToggle/ThemeToggle.web.tsx | View in GitLab}
 *
 * @scope Platform
 */ const ThemeToggle = ({ onThemeChange, ...props })=>{
    const { setTheme } = useAviaryTheme.useAviaryTheme();
    const currentTheme = react.useTheme();
    const isDarkMode = currentTheme.theme === "dark";
    const handleThemeChange = (isChecked)=>{
        const newTheme = isChecked ? "dark" : "light";
        onThemeChange?.(newTheme);
        setTheme(newTheme);
    };
    return /*#__PURE__*/ jsxRuntime.jsx(InternalToggle_web.InternalToggle, {
        id: "theme-toggle",
        icon: isDarkMode ? index.faMoon : index.faSunBright,
        label: isDarkMode ? "Dark mode" : "Light mode",
        isChecked: isDarkMode,
        onCheckedChange: handleThemeChange,
        "data-testid": "aviary-theme-toggle",
        ...props
    });
};

exports.ThemeToggle = ThemeToggle;
//# sourceMappingURL=ThemeToggle.web.cjs.map
